import './styles/TextBadge.scss';

import * as React from 'react';

import Text from 'components/Text';
import cx from 'classnames';

type NonDefaultProps = {
  children: React.ReactNode;
  className?: string;
};

export type TextBadgeColor =
  | 'chalkboard'
  | 'apple'
  | 'atlas'
  | 'ruler'
  | 'paper'
  | 'eraser'
  | 'graphite'
  | 'pencil'
  | 'apple-lightest'
  | 'mascot'
  | 'info'
  | 'open-status';
export type TextBadgeTextColor =
  | 'whiteout'
  | 'graphite'
  | 'chalkboard'
  | 'apple'
  | 'elmer'
  | 'mascot'
  | 'info'
  | 'open-status';

type DefaultProps = {
  color?: TextBadgeColor;
  textSize?: 'xsmall' | 'xxxxsmall';
  textColor?: TextBadgeTextColor;
  textWeight?: 'normal' | 'semibold';
};

export type Props = NonDefaultProps & DefaultProps;

const TextBadge: React.FC<Props> = (props) => {
  const { color, textColor, textWeight, textSize, children, className } = props;

  return (
    <Text
      weight={textWeight}
      size={textSize}
      className={cx(
        'TextBadge',
        `TextBadge--${color}`,
        `TextBadge--${textSize}`,
        `TextBadge--text-${textColor}`,
        className
      )}
      element="div"
    >
      {children}
    </Text>
  );
};

TextBadge.defaultProps = {
  color: 'paper',
  textColor: 'graphite',
  textWeight: 'semibold',
  textSize: 'xsmall',
};

export default TextBadge;
